import { useFeatureFlag } from '~/lib/launchDarkly';

export const useMigratedEndpoint = (endpoint: string): boolean => {
  const migratedEndpoints = useFeatureFlag<Record<string, boolean>>(
    'Feature.Scalability.Endpoints',
    {},
  );

  return migratedEndpoints[endpoint] || false;
};
